import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { ShoppingCart, Menu, X, Home, Info, Package } from 'lucide-react';
import AuthButton from './AuthButton';
import './MainNavigation.css';

const MainNavigation = ({ onCartOpen, currentPage, onPageChange }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { getTotalItems } = useCart();

  // Détecter le scroll pour changer l'apparence de la navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCartClick = () => {
    if (onCartOpen) {
      onCartOpen();
    }
  };

  const handlePageChange = (page) => {
    onPageChange(page);
    setIsMenuOpen(false);
  };


  const menuItems = [
    { id: 'accueil', label: 'Accueil', icon: Home },
    { id: 'produits', label: 'Nos Produits', icon: Package },
    { id: 'histoire', label: 'Notre Histoire', icon: Info }
  ];

  return (
    <nav className={`main-navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        {/* Logo */}
        <div 
          className="nav-logo" 
          onClick={() => handlePageChange('accueil')}
          style={{ cursor: 'pointer' }}
        >
          <img src="/images/AB.png" alt="Certification Agriculture Biologique" className="nav-ab-logo" />
          <h2>La Ferme À L'Ancienne</h2>
        </div>

        {/* Navigation principale */}
        <div className="nav-links">
          {menuItems.map(item => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handlePageChange(item.id)}
              >
                <IconComponent size={18} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>

        {/* Actions (panier, auth et menu mobile) */}
        <div className="nav-actions">
          <div className="cart-icon" onClick={handleCartClick}>
            <ShoppingCart size={20} />
            {getTotalItems() > 0 && (
              <span className="cart-badge">{getTotalItems()}</span>
            )}
          </div>
          
          <AuthButton />
          
          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      {isMenuOpen && (
        <>
          <div 
            className="mobile-menu-overlay"
            onClick={() => setIsMenuOpen(false)}
          />
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <button 
              className="mobile-menu-close"
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
              }}
              aria-label="Fermer le menu"
            >
              <X size={24} />
            </button>
            <div className="mobile-menu-content">
              {menuItems.map(item => {
                const IconComponent = item.icon;
                return (
                  <button
                    key={item.id}
                    className={`mobile-menu-item ${currentPage === item.id ? 'active' : ''}`}
                    onClick={() => handlePageChange(item.id)}
                  >
                    <IconComponent size={18} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default MainNavigation;
